import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { GitHubIcon } from './GitHubIcon';

export default createWebRegistration({
  authProviders: {
    github: {
      icon: GitHubIcon,
      benefit: 'Required for repository access and PR review automation',
    },
  },
});
